import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './LaunchPlanField.scss';

const LAUNCH_PLAN_SOURCE_NOTES = {
  default: 'Default',
  launch_row: 'Kept from when it launched'
};

// Yes with a number, or No. Saving null puts the field back on its default.
const LaunchPlanField = ({ value, source, unit, max, yesValue, canEdit, describe, onSave }) => {
  const [draft, setDraft] = useState(null);
  useEffect(() => setDraft(null), [value]);
  const commitDraft = () => {
    const next = Number(draft);
    if (draft !== null && next >= 1 && next !== value) onSave(next);
    setDraft(null);
  };
  const amount = unit === '%' ? `${value}%` : `${value} ${unit}`;
  return (
    <div className='mode-control launch-plan-field'>
      {canEdit ? (
        <>
          {[
            { label: 'Yes', isCurrent: value > 0, next: yesValue },
            { label: 'No', isCurrent: !value, next: 0 }
          ].map(option => (
            <button
              key={option.label}
              type='button'
              className={cn('mode-segment', { current: option.isCurrent })}
              disabled={option.isCurrent}
              onClick={() => onSave(option.next)}
            >
              {option.label}
            </button>
          ))}
          {value > 0 && (
            <label className='launch-plan-amount'>
              <input
                type='number'
                min='1'
                max={max}
                value={draft ?? value}
                onChange={e => setDraft(e.target.value)}
                onBlur={commitDraft}
                onKeyDown={e => e.key === 'Enter' && e.target.blur()}
              />
              {unit}
            </label>
          )}
        </>
      ) : (
        <span>{value ? amount : 'No'}</span>
      )}
      <span className='mode-extra'>{describe(value)}</span>
      <span className='mode-extra muted'>
        {source === 'plan' ? (
          <>
            Set on this notification
            {canEdit && (
              <>
                {' · '}
                <button type='button' className='link' onClick={() => onSave(null)}>
                  use the default
                </button>
              </>
            )}
          </>
        ) : (
          LAUNCH_PLAN_SOURCE_NOTES[source] || 'Default'
        )}
      </span>
    </div>
  );
};

LaunchPlanField.propTypes = {
  value: PropTypes.number.isRequired,
  source: PropTypes.oneOf(['plan', 'launch_row', 'default']).isRequired,
  unit: PropTypes.string.isRequired,
  max: PropTypes.number.isRequired,
  yesValue: PropTypes.number.isRequired,
  canEdit: PropTypes.bool.isRequired,
  describe: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
};

export default LaunchPlanField;
